/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// BASE Components
import BASESvgIcon from "../../../../../@BASE/core/BASESvgIcon";
// material-ui
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function EmptyVersionsCard(props) {

    const { resource } = props;

    return (
        <Paper elevation={0} variant="outlined" className="p-16 flex flex-col items-center w-full rounded-16">
            <BASESvgIcon size={24}>
                heroicons-outline:exclamation
            </BASESvgIcon>
            <Typography className="text-12 font-medium" color="text.secondary">
                There are no stored versions of this {resource}.
            </Typography>
        </Paper>
    );
}

export default EmptyVersionsCard;
